export class ExpandableItem {
  constructor(element) {
    const {variant, initialised} = element.dataset;
    this.element = element;
    this.chevron = element.querySelector('.js-chevron');

    /** todo: find a less generic class name for the menu */
    this.menu = element.querySelector('.js-expandable-menu');

    if (initialised !== 'true') {
      element.dataset.initialised = 'true';
      element.dataset.state = 'closed';

      if (variant === 'desktop') {
        this.openStyle = 'hover';
        element.addEventListener('mouseover', () => this.openMenu());
        element.addEventListener('mouseout', () => this.closeMenu());
      } else {
        this.openStyle = 'click';
        element.addEventListener('click', () => this.toggleMenu());
      }
    }
  }

  closeMenu() {
    const { state } = this.element.dataset;
    if (state !== 'closed') this.element.dataset.state = 'closed';

    if (this.openStyle === 'click') {
      this.removeOverlay();
    }
  }

  openMenu() {
    const { state } = this.element.dataset;
    if (state !== 'openend') this.element.dataset.state = 'openend';

    if (this.openStyle === 'click') {
      this.addOverlay();
    }
  }

  addOverlay() {
    const overlayElement = document.createElement('div');
    overlayElement.className = 'js-expandable-overlay expandable-overlay';
    overlayElement.onclick = () => this.closeMenu();

    const target = this.element.parentElement;

    if (target) {
      this.overlayElement = overlayElement;
      target.appendChild(overlayElement);
    }
  }

  removeOverlay() {
    if (this.overlayElement) {
      this.overlayElement.remove();
    }
  }

  toggleMenu(element) {
    const { state } = this.element.dataset;

    if (state === 'openend') {
      this.closeMenu(element);
    } else {
      this.openMenu(element);
    }
  }
}